/**
 * User-facing copy for the RM Magazine Editor's "Publish magazine" flow, which
 * regenerates the magazine and sends it to print once the render is finished.
 * Per the project rule, no feature text is inlined in a component.
 */
export const magazinePublishStrings = {
  // Shown under the publish loader while the regeneration runs.
  generating: 'Generating the magazine. This can take a few minutes.',
  sending: 'Sending the magazine to print...',
  // The wait gave up; a second click resumes waiting on the same render.
  stillGenerating:
    'Still generating — click Publish magazine again in a minute to send it to print.',
  couldNotStart:
    'Could not start generating the magazine. Click Publish magazine again.',
  generationFailed:
    'The magazine could not be generated, so it was not sent to print. Check the magazine and click Publish magazine again.',
  superseded:
    'A newer version of this magazine started generating, so this one was not sent to print. Click Publish magazine again.',
  alreadySent: 'This magazine has already been sent to print.',
};
